import CompanyInformationTab from "components/housingCompany/details/CompanyInformation/CompanyInformationTab";
import ExternalCompanyInformationTab from "components/housingCompany/details/CompanyInformation/ExternalCompanyInformationTab";
import FinancialAnalysisTab from "components/housingCompany/details/FinancialAnalysis/FinancialAnalysisTab";
import HousingCompanyDetailsTabs from "components/housingCompany/details/HousingCompanyDetailsTabs";
import ShareHolderAnalysis from "components/housingCompany/details/ShareHolderAnalysis/ShareHolderAnalysis";
import LtvAnalysis from "components/housingCompany/details/LtvAnalysis/LtvAnalysis";
import PtsTab from "components/housingCompany/details/Pts/PtsTab";
import AdminLayout from "components/layouts/AdminLayout";
import { Empty } from 'antd';
import { useState } from 'react';
import { useParams } from 'react-router';
import { TranslateString } from "Utils/Common";

function HousingCompanyAnalysis(props: any) {
    const [selectedTab, setSelectedTab] =  useState<number>(1);
    const [externalCustomer, setExternalCustomer] = useState<any>(false);

    props = {...props,...useParams()}
    return (
        <AdminLayout>
            <HousingCompanyDetailsTabs externalCustomer={externalCustomer} setExternalCustomer={setExternalCustomer}  selectedTab={selectedTab} selectTab={setSelectedTab} {...props}/>
            {
                (()=>{
                    switch(selectedTab) {
                        case 1:
                          return externalCustomer ? <ExternalCompanyInformationTab {...props} /> : <CompanyInformationTab {...props}/>;
                        case 2:
                            return <FinancialAnalysisTab {...props}/>
                        case 3:
                            return <ShareHolderAnalysis {...props}/>
                        case 4:
                            return <LtvAnalysis {...props} externalCustomer={externalCustomer}/>;
                        case 5:
                            return <PtsTab {...props}/>;
                        case 6:
                            return <Empty description={TranslateString('Empty')}/>;
                        default:
                            return selectedTab;
                    }
                })()
            }
        </AdminLayout>
    );
}

export default HousingCompanyAnalysis;